module.exports = __webpack_public_path__ + "media/images/amenities_icons/bike-storage-0db841cfb5e2be31f95b04fb4e63bd46.svg";